// extracted by mini-css-extract-plugin
module.exports = {"ReferenceDisplayWrapper":"ReferenceEditor_ReferenceDisplayWrapper__qBthu","ReferenceDisplay":"ReferenceEditor_ReferenceDisplay__MaTlt"};